import React from "react";
import { Upload, Download, FileText, Coins } from "lucide-react";

export const ImportBar = ({
  uploading, extracting, fileRef, labRef,
  handleCsvUpload, extractLab, downloadTemplate,
  credits, buyCredits, buyingCredits,
}) => (
  <>
    <div className="mt-8 bg-[#2D322B] text-[#F9F6F0] rounded-3xl p-6 flex flex-col md:flex-row md:items-center gap-4" data-testid="csv-import-bar">
      <div className="flex-1">
        <p className="label-eyebrow !text-[#D49A44]">Backfill your trail</p>
        <p className="font-serif text-xl mt-1">Two ways to add months of biomarkers in seconds.</p>
        <p className="text-xs text-[#F9F6F0]/70 mt-1">CSV (columns: marker, value, unit, date, notes) — or upload a lab PDF/image and Massey&apos;s vision will extract every value. Up to 25 MB; large PDFs are split automatically.</p>
      </div>
      <div className="flex flex-wrap gap-3 items-center">
        <button onClick={downloadTemplate} className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#D49A44] hover:text-[#F9F6F0]" data-testid="csv-template-btn">
          <Download className="w-3.5 h-3.5" /> Template
        </button>
        <label className="btn-secondary !border-[#F9F6F0]/40 !text-[#F9F6F0] hover:!bg-[#F9F6F0] hover:!text-[#2D322B] inline-flex items-center gap-2 cursor-pointer" data-testid="csv-upload-label">
          <Upload className="w-4 h-4" />
          {uploading ? "Importing…" : "Upload CSV"}
          <input ref={fileRef} type="file" accept=".csv" onChange={handleCsvUpload} className="hidden" data-testid="csv-upload-input" disabled={uploading} />
        </label>
        <label className="btn-primary !bg-[#D49A44] !text-[#2D322B] hover:!bg-[#bf8a3a] inline-flex items-center gap-2 cursor-pointer" data-testid="lab-upload-label">
          <FileText className="w-4 h-4" />
          {extracting ? "Reading lab…" : "Upload Lab PDF/Image"}
          <input ref={labRef} type="file" accept=".pdf,.png,.jpg,.jpeg,.webp,.heic" onChange={extractLab} className="hidden" data-testid="lab-upload-input" disabled={extracting} />
        </label>
      </div>
    </div>

    {credits && (
      <div className="mt-3 px-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-[#5C6359]" data-testid="credits-bar">
        <p>
          <span className="text-[#D49A44] font-medium">{credits.total_available}</span> lab extraction credit{credits.total_available === 1 ? "" : "s"} available
          {credits.monthly_quota > 0 && (
            <> · {credits.monthly_remaining}/{credits.monthly_quota} this month</>
          )}
          {credits.balance > 0 && <> · {credits.balance} purchased</>}
          <span className="mx-2 text-[#D1C7B8]">·</span>
          <span>1 credit per extraction</span>
        </p>
        <button
          onClick={buyCredits}
          disabled={buyingCredits}
          data-testid="buy-credits-btn"
          className="inline-flex items-center gap-1 text-[#C05C42] hover:text-[#2D322B] uppercase tracking-widest disabled:opacity-60"
        >
          <Coins className="w-3.5 h-3.5" />
          {buyingCredits ? "Opening…" : (credits.pack ? `Buy ${credits.pack.credits} for $${credits.pack.amount_usd}` : "Buy credits")}
        </button>
      </div>
    )}
  </>
);
